import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "3",
  height: "13",
  viewBox: "0 0 3 13",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "1.5",
  cy: "1.5",
  r: "1.5",
  fill: "#615F5A"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "1.5",
  cy: "6.5",
  r: "1.5",
  fill: "#615F5A"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "1.5",
  cy: "11.5",
  r: "1.5",
  fill: "#615F5A"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}